"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require("react-redux");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state, ownProps) {
    return {
        isShown: state.cart.midCartVisibility
    };
}

var LsPopupReact = (_dec = (0, _reactRedux.connect)(mapStateToProps), _dec(_class = (_temp = _class2 = function (_React$Component) {
    (0, _inherits3.default)(LsPopupReact, _React$Component);

    function LsPopupReact(props) {
        (0, _classCallCheck3.default)(this, LsPopupReact);

        var _this = (0, _possibleConstructorReturn3.default)(this, (LsPopupReact.__proto__ || (0, _getPrototypeOf2.default)(LsPopupReact)).call(this, props));

        _this.overlayClick = function (event) {
            if (event.target !== document.getElementById(_this.overlayIdentifier) && !event.target.closest('.ls-popup-close-button')) {
                event.stopPropagation();
                return;
            }
            _this.props.close(event);
        };

        _this.mainIdentifier = props.mainIdentifier || "lsPopup_" + new Date().getTime();
        _this.overlayIdentifier = _this.mainIdentifier + "_overlay";
        return _this;
    }

    (0, _createClass3.default)(LsPopupReact, [{
        key: "render",
        value: function render() {
            return _react2.default.createElement(
                "figure",
                { id: this.overlayIdentifier, onClick: this.overlayClick,
                    className: "ls-popup-overlay " + (this.props.isShown ? 'opened' : '') + " " + this.props.parentClassName },
                _react2.default.createElement(
                    "section",
                    { id: this.mainIdentifier, className: "ls-popup-main" },
                    _react2.default.createElement(
                        "button",
                        { onClick: this.overlayClick, className: "ls-popup-close-button close" },
                        _react2.default.createElement(
                            "span",
                            {
                                "aria-hidden": "true" },
                            "\xD7"
                        )
                    ),
                    this.props.title ? _react2.default.createElement(
                        "div",
                        { className: "ls-popup-title" },
                        this.props.title
                    ) : '',
                    _react2.default.createElement(
                        "section",
                        { className: "ls-popup-body" },
                        this.props.children
                    ),
                    this.props.footer ? _react2.default.createElement(
                        "section",
                        { className: "ls-popup-footer" },
                        this.props.footer
                    ) : ''
                )
            );
        }
    }]);
    return LsPopupReact;
}(_react2.default.Component), _class2.propTypes = {
    mainElementId: _propTypes2.default.string,
    overlayIdentifier: _propTypes2.default.string,
    isShown: _propTypes2.default.bool,
    title: _propTypes2.default.string,
    footer: _propTypes2.default.string,
    close: _propTypes2.default.func,
    parentClassName: _propTypes2.default.string
}, _temp)) || _class);
exports.default = LsPopupReact;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/lsPopupReact.js
// module id = 1085
// module chunks = 0